<template>
  <v-menu offset-y>
    <template #activator="{ props }">
      <v-btn v-bind="props" icon>
        <v-icon>mdi-translate</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="lang in availableLanguages"
        :key="lang.code"
        :class="{ 'v-list-item--active': currentLocale === lang.code }"
        @click="changeLanguage(lang.code)"
      >
        <template #prepend>
          <v-icon>{{ lang.icon }}</v-icon>
        </template>
        <v-list-item-title>{{ lang.name }}</v-list-item-title>
        <template v-if="currentLocale === lang.code" #append>
          <v-icon>mdi-check</v-icon>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const menuOpen = ref(false);

const availableLanguages = [
  { code: 'en', name: 'English', icon: 'mdi-flag' },
  { code: 'es', name: 'Español', icon: 'mdi-flag' },
];

const currentLocale = computed(() => locale.value);

const changeLanguage = (langCode: string) => {
  locale.value = langCode;
  menuOpen.value = false;
  localStorage.setItem('preferredLanguage', langCode);
};
</script>

<style scoped>
.v-list-item--active {
  background-color: rgba(var(--v-theme-primary), 0.1);
}
</style>
